// #1385 — garage opening hours. A close time before the open time runs past midnight into the next
// day (05:00–02:00); equal open and close times mean open 24 hours (00:00–00:00). The backend
// open-now check and the app read the hours the same way.

/** "09:00:00" / "9:00" → "09:00"; anything unreadable is returned as is. */
export function hm(time: string | null | undefined): string {
  const m = /^(\d{1,2}):(\d{2})/.exec((time ?? '').trim());
  return m ? `${m[1].padStart(2, '0')}:${m[2]}` : (time ?? '');
}

export const isAllDay = (open: string | null | undefined, close: string | null | undefined) =>
  !!open && !!close && hm(open) === hm(close);

export const closesNextDay = (open: string | null | undefined, close: string | null | undefined) =>
  !!open && !!close && hm(close) < hm(open);

/** "09:00 – 18:00", "05:00 – 02:00 (next day)" or "Open 24 hours". */
export function formatHours(open: string | null | undefined, close: string | null | undefined): string {
  if (isAllDay(open, close)) return 'Open 24 hours';
  const range = `${hm(open)} – ${hm(close)}`;
  return closesNextDay(open, close) ? `${range} (next day)` : range;
}
